<template>
  <div id="container">
    <div
      class="item-box-content"
      v-show="$route.query.type !== 'red'"
    >
      <div class="title-font-style">
        <span>退货信息</span>
      </div>
      <el-form style="padding:20px 30px 0 10px">
        <el-row :gutter="20">
          <el-col :span="16">
            <el-form-item
              label="售后类型："
              label-width="88px"
            >{{'退货'}}
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item
              label="退货说明："
              label-width="88px"
            >
              <el-input
                type="textarea"
                v-model.trim="mark"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="item-box-content">
      <div class="title-font-style">
        <span>产品清单</span>
      </div>
      <el-table
        style="margin-top:20px;"
        border
        ref="tableRef"
        :data="list"
        tooltip-effect="dark"
        highlight-current-row
        :header-cell-style="tableHeader"
        element-loading-text="拼命加载中请稍后..."
        max-height="378"
        @selection-change="handleSelectionChange"
        @row-dblclick="RowDbclick"
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column
          show-overflow-tooltip
          type="selection"
          width="55"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="brandName"
          label="品牌"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="proModel"
          label="型号"
        >
          <template slot-scope="scope">
            <div class="approval line-limit-length" @click="goProIdDetail(scope.row)">{{scope.row.proModel}}</div>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="proOrderNum"
          label="订货号"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="proUnit"
          label="单位"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="retreatCount"
          label="数量"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="proExType"
          label="类型"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="pcbExTimeValue"
          label="货期"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.pcbExTimeValue+'天' }}</div>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="cbRemind"
          min-width="140"
          label="提醒"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.cbRemind | dateFilter }}</div>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="purchasePrice"
          label="采购单价"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.purchasePrice | priceFilterNum }}</div>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="discountPrice"
          label="抵扣金额"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.discountPrice | priceFilterNum }}</div>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="actualPrice"
          label="实付单价"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.actualPrice | priceFilterNum }}</div>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="proPrice"
          label="面价"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.proPrice | priceFilterNum }}</div>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="deliverState"
          label="发货状态"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="invoiceState"
          label="收票状态"
        ></el-table-column>
      </el-table>
      <el-button
        @click="moveInReturnArea"
        :disabled="list.length ===0"
        style="margin-top:20px;"
      >移入退货区
      </el-button>
    </div>
    <div class="item-box-content">
      <div class="title-font-style">
        <span>退货区</span>
      </div>
      <el-button
        style="margin-top:20px;"
        @click="moveOutReturnArea"
        :disabled="listReturn.length ===0"
      >移出退货区
      </el-button>
      <el-table
        style="margin-top:20px;"
        border
        ref="tableRef"
        :data="listReturn"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
        @selection-change="handleSelectionChangeReturn"
        @row-dblclick="RowDbclickReturn"
        element-loading-text="拼命加载中请稍后..."
        max-height="378"
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column
          show-overflow-tooltip
          type="selection"
          width="55"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="brandName"
          label="品牌"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="proModel"
          label="型号"
        >
          <template slot-scope="scope">
            <div class=" line-limit-length">{{scope.row.proModel}}</div>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="proOrderNum"
          label="订货号"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="proUnit"
          label="单位"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="proExType"
          label="类型"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="pcbExTimeValue"
          label="货期"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.pcbExTimeValue+'天' }}</div>
          </template>
        </el-table-column>

        <el-table-column
          show-overflow-tooltip
          prop="purchasePrice"
          label="采购单价"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.purchasePrice | priceFilterNum }}</div>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="discountPrice"
          label="抵扣金额"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.discountPrice | priceFilterNum }}</div>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="actualPrice"
          label="实付单价"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.actualPrice | priceFilterNum }}</div>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="deliverState"
          label="发货状态"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="invoiceState"
          label="收票状态"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="retreatCount"
          label="数量"
        >
          <template slot-scope="scope">
            <el-input-number
              style="width:100%;"
              v-model="scope.row.retreatCount"
              :controls="false"
              :min="0"
              :precision="0"
              :max="scope.row.pccCount"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="type"
          min-width="100"
          label="产品序列号"
        >
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.serialCode ===null||scope.row.serialCode ===''"
              @click="entering(scope.row, scope.$index)"
              type="text"
            >点击录入
            </el-button>
            <el-button
              v-else
              @click="updateing(scope.row, scope.$index)"
              type="text"
            >编辑
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="confiscateMoney"
          label="罚没单价"
        >
          <template slot-scope="scope">
            <el-input-number
              style="width:100%;"
              @change="confiscateMoneyChange"
              v-model="scope.row.confiscateMoney"
              :controls="false"
              :min="0"
              :max="scope.row.actualPrice"
              :precision="2"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column
          prop="confiscatedRatio"
          min-width="120"
          label="罚没比例"
        >
          <template slot-scope="scope">
            <el-input-number
              style="width:80%;"
              @change="confiscatedRatioChange"
              v-model="scope.row.confiscatedRatio"
              :controls="false"
              :min="0"
              :precision="2"
              :max="100"
            ></el-input-number>
            <span>{{'%'}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-row style="margin-top:20px;">
      <el-col :span="24">
        <el-button
          @click="onApplyForRefund"
          type="primary"
        >提交
        </el-button>
      </el-col>
    </el-row>
    <!-------------- 申请退款二次确认 -------------->
    <open-or-close
      ref="OpenOrCloseRefs"
      @onUpdataState="onUpdataState"
      :title="title"
      :content="content"
    ></open-or-close>
    <!-- 序列号 -->
    <inprouct-serial-code-dialog
      @inProuctSerial="inProuctSerial"
      ref="inProuctSerialCodeRefs"
    ></inprouct-serial-code-dialog>
  </div>
</template>
<script>
import { queryLaunchRetreat, addRetreat } from '@/api/purchase/purchasePlanList'
import { formatDate } from '@/util/tool'
import { deepClone } from '@/util'

import openOrClose from '@/components/OpenOrClose/index'
import inProuctSerialCodeDialog from '../../dialog/inProuctSerialCodeDialog'
import * as NP from 'number-precision' // 序列号

export default {
  components: {
    'open-or-close': openOrClose,
    'inprouct-serial-code-dialog': inProuctSerialCodeDialog

  },
  data () {
    return {
      mark: '',
      waitMoveListReturn: [],
      listReturn: [],
      waitMoveList: [],
      listDeepClone: [],
      list: [],
      title: '',
      content: '',
      returnTicket: '' // 退票清单
    }
  },
  watch: {
    listReturn: {
      handler (newVal) {
        this.list = deepClone(this.listDeepClone)

        for (let i = 0; i < this.list.length; i++) {
          for (let j = 0; j < this.listReturn.length; j++) {
            if (this.listReturn[j].id === this.list[i].id) {
              if (this.listReturn[j].retreatCount === undefined) {
                this.listReturn[j].retreatCount = 0
              }
              this.list[i].retreatCount = this.list[i].pccCount - this.listReturn[j].retreatCount
            }
          }
        }
        for (let i = 0; i < this.list.length; i++) {
          if (this.list[i].retreatCount === 0) {
            this.list.splice(i, 1)
            i--
          }
        }
        for (let j = 0; j < this.listReturn.length; j++) {
          if (this.listReturn[j].retreatCount === 0) {
            this.listReturn.splice(j, 1)
            j--
          }
        }
      },
      deep: true
    }
  },
  mounted () {
    queryLaunchRetreat(this.$route.query.pcbId)
      .then(res => {
        if (res.data.code === 200) {
          this.list = res.data.obj
          this.list.forEach((ele, index) => {
            ele.retreatCount = ele.pccCount
            ele.confiscateMoney = 0
            ele.confiscatedRatio = 0
            ele.id = index
          })
          this.listDeepClone = deepClone(this.list)
        }
      })
      .catch(err => {
        console.log(err)
      })
  },
  methods: {
    goProIdDetail(row) {
      this.$router.push({
        name: 'productDetails',
        query: {
          id: row.proId || row.id
        }
      })
    },
    // 罚没单价
    confiscateMoneyChange () {
      this.listReturn.forEach(element => {
        element.confiscatedRatio = ((element.confiscateMoney / element.actualPrice).toFixed(4)) * 100
      })
    },
    // 罚没比例
    confiscatedRatioChange () {
      this.listReturn.forEach(element => {
        element.confiscateMoney = (element.actualPrice * (element.confiscatedRatio * 0.01)).toFixed(2)
      })
    },
    // 移入退货区
    moveInReturnArea () {
      if (this.waitMoveList.length === 0) {
        this.$message.error('请选择要移入的产品！')
      } else {
        this.waitMoveList.forEach(ele => {
          this.RowDbclick(ele)
        })
        this.waitMoveList = []
      }
    },
    // 移出退货区
    moveOutReturnArea () {
      if (this.waitMoveListReturn.length === 0) {
        this.$message.error('请选择要移出的产品！')
      } else {
        this.waitMoveListReturn.forEach(ele => {
          this.RowDbclickReturn(ele)
        })
        this.waitMoveList = []
      }
    },
    // 退货区选中
    handleSelectionChangeReturn (value) {
      this.waitMoveListReturn = value
    },
    // 移入的双击
    RowDbclickReturn (row) {
      this.listReturn.forEach(ele => {
        if (ele.id === row.id) {
          ele.retreatCount = 0
        }
      })
    },
    // 移入的双击
    RowDbclick (row) {
      let isFalse = false

      this.listReturn.forEach(ele => {
        if (ele.id === row.id) {
          ele.retreatCount = ele.pccCount
          isFalse = true
        }
      })
      if (!isFalse) {
        this.listReturn.push(row)
      }
    },
    handleSelectionChange (value) {
      this.waitMoveList = value
    },
    // 编辑
    updateing (val, index) {
      this.$refs.inProuctSerialCodeRefs.onInitial(val, index, 1)
    },
    // 录入
    entering (val, index) {
      this.$refs.inProuctSerialCodeRefs.onInitial(val, index, 0)
    },
    inProuctSerial (val, index) {
      this.listReturn[index].serialCode = val
      this.listReturn = deepClone(this.listReturn)
    },

    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },

    // 申请退票
    onApplyForRefund () {
      if (this.mark === undefined || this.mark === '') {
        this.$message.error('请填写退货说明！')
      } else {
        if (this.listReturn.length === 0) {
          this.$message.error('请至少选择一个退货产品！')
        } else {
          this.title = '确认提交'
          this.content = '请再次确认退货产品，提交后将由上级进行审批'
          this.$refs.OpenOrCloseRefs.onInitial()
        }
      }
    },
    onUpdataState () {
      const params = {}
      params.pcbId = this.$route.query.pcbId
      params.mark = this.mark
      const a = deepClone(this.listReturn)
      params.purchaseLaunchRetreatVoList = a.map(item => {
        item.confiscatedRatio = NP.strip(item.confiscatedRatio / 100)
        return item
      })
      addRetreat(params)
        .then(res => {
          if (res.data.code === 200) {
            this.$message.success('已申请退货，请等待审核！')
            this.$router.push({
              name: 'salesReturnDetail',
              query: {
                pcbId: this.$route.query.pcbId,
                pcrId: res.data.obj
              }
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  filters: {
    dateFilter
  }
}

function dateFilter (time) {
  if (time === null) {
    return '--'
  } else {
    const date = new Date(time)
    return formatDate(date, 'yyyy-MM-dd hh:mm')
  }
}
</script>
<style
  lang="scss"
  scoped
></style>
